// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__31sz7","title":"ClientCherryInfo_title__11S7w","itemText":"ClientCherryInfo_itemText__2bHYY"};